import store from "@/store"

window.DEBUGG = false

var timeouts = {}
var prefix = "nv"
var options = {
  enable: {
    status: false,
    excepted: [],
    sendEventToElements: false
  },
  holding: false,
  FOV: 180,
  prefix: prefix,
  attr: prefix,
  attrScope: prefix + "-scope",
  attrScopeFOV: prefix + "-scope-fov",
  attrScopeCurrent: prefix + "-scope-current",
  attrElement: prefix + "-el",
  attrElementFOV: prefix + "-el-fov",
  attrElementCurrent: prefix + "-el-current"
}

/**
 * Navigation object
 * @returns {Nav}
 * @constructor
 */
var Nav = function() {
  if (Nav.instance) {
    return Nav.instance
  }

  Nav.instance = this
  return Nav.instance
}

/**
 * Switch debug mode
 * @param flag
 */
Nav.prototype.debug = function(flag) {
  return (DEBUGG = flag)
}
Nav.prototype.options = function() {
  return options
}
/**
 * Registered navigation scopes
 * @type {NavScope[]}
 * @private
 */
Nav.prototype._scopes = {}

/**
 * Current navigation scope
 * @type {NavScope}
 */
Nav.prototype._currentScope = null

/**
 * Previous navigation scope
 * @type {NavScope}
 * @private
 */
Nav.prototype._prevScope = null

/**
 * Key mapping [keyCode, eventName, value]
 * @type {Array}
 * @private
 */
Nav.prototype._keyMapping = []

/**
 * Initialize navigation
 * @returns {Nav}
 */
Nav.prototype.initialize = function(scope = null) {
  var self = this,
    body = document.body,
    container = !scope ? body : document.getElementById(scope) || body,
    navElements = getElementsByAttributeName(container.children, options.attrElement)

  return new Promise(function(resolve) {
    body.addEventListener("keydown", self)
    body.addEventListener("keyup", self)

    navElements.forEach(function(element) {
      //if (!element.offsetParent) return false
      self.addElement(element)
    })

    if (!self.getCurrentScope()) {
      DEBUGG && console.log("not found current scope")
    }

    resolve(self)
  })
}

/**
 * Deinitialize navigation
 */
Nav.prototype.deinitialize = function(scope = null) {
  var self = this
  scope ? delete this._scopes[scope] : (this._scopes = {})
  !scope && (this._currentScope = null)
  !scope && (this._prevScope = null)
  document.body.removeEventListener("keydown", self)
  document.body.removeEventListener("keyup", self)
}

/**
 * Refresh navigation
 */
Nav.prototype.refresh = function() {
  this.deinitialize()
  this.initialize()
}

/**
 * Refresh navigation
 */
Nav.prototype.refreshScope = function(scope, includeVisibles = false) {
  scope = this.getScope(scope) || this.getCurrentScope()
  if (!scope) return

  scope.currentElement = false
  let navElements = getElementsByAttributeName(scope.element.children, options.attrElement)
  if (!includeVisibles) scope.navigationElements = navElements.filter(element => element.offsetParent)
  else scope.navigationElements = navElements

  scope.navigationElements.forEach(element => {
    scope.cleanCurrentElement(element)
  })

  var firstElement = scope.getFirstElement()
  if (this.isCurrentScope(scope)) this.move(firstElement)

  //else scope.setCurrentElement(firstElement)
  //scroll(scope.element, scope.currentElement, true)
}

/**
 * Sync navigation
 */
Nav.prototype.sync = async function(scope = null, select = false) {
  DEBUGG && console.log("Starting navigation sync.")
  var self = this
  this.removeScope(scope)
  return this.initialize(scope)
    .then(() => {
      select && self.changeScope(scope)
      return true
    })
    .catch(err => _$.error(err))
}

/**
 * Enable navigation
 */
Nav.prototype.enable = function() {
  options.enable.status = true
  options.enable.excepted = []
  this.createTimeout()
  return true
}

/**
 * Disable navigation
 */
Nav.prototype.disable = function(excepted, sendEventToElements = false) {
  options.enable.status = false
  options.enable.excepted = Array.isArray(excepted) ? excepted : []
  options.enable.sendEventToElements = sendEventToElements
  if (timeouts.isAwake) _$.removeTimeout(timeouts.isAwake)
  return true
}

/**
 * Create sleep timeouts
 */
Nav.prototype.createTimeout = function() {
  let osdDuration

  try {
    osdDuration = parseInt(__.device.config("osdDuration.osdDuration"))
  } catch (error) {
    osdDuration = 8000
  }

  if (timeouts.isAwake) _$.removeTimeout(timeouts.isAwake)
  timeouts.isAwake = _$.makeTimeout(() => {
    if (!this._currentScope) return this.createTimeout()
    if (this._currentScope.element.getAttribute("nv-sleep-protect") !== "") _$.vue.$emit("sleep", true)

    this.createTimeout()
  }, osdDuration)

  return true
}

/**
 * Return navigation options
 * @returns {object}
 */
Nav.prototype.getOptions = function() {
  var opt = clone(options)
  return opt
}

/**
 * Set option by name
 * @param key option name
 * @param value option value
 * @returns {Nav}
 */
Nav.prototype.setOption = function(key, value) {
  options[key] = value
  return this
}

/**
 * Return key/value key binding
 * @returns {object}
 */
Nav.prototype.getKeyMapping = function() {
  return this._keyMapping
}

/**
 * Override current key mapping
 * @param {Array} keyMapping
 * @returns {Nav}
 */
Nav.prototype.setKeyMapping = function(keyMapping) {
  this._keyMapping = keyMapping
  return this
}

/**
 * Add keyMapping to current nav
 * @param keyMapping
 * @returns {Nav}
 */
Nav.prototype.addKeyMapping = function(keyMapping) {
  this._keyMapping = this._keyMapping.concat(keyMapping)
  return this
}

/**
 * Add scope to navigation
 * @param {HTMLElement} element
 * @returns {Nav}
 */
Nav.prototype.addScope = function(element) {
  var self = this,
    navScope = new NavScope(element)

  self._scopes[navScope.name] = navScope
  // is current
  var attrCurrentScope = element.getAttribute(options.attrScopeCurrent)
  if (attrCurrentScope === "" || attrCurrentScope === "true") {
    DEBUGG && console.info(navScope.name, ": is current scope")
    self._setCurrentScope(navScope)
  }

  // trick listen remove from DOM
  var _remove = element.remove
  element.remove = function() {
    self.removeScope(element)
    _remove.call(element)
  }

  addClass(element, options.attrScope)

  return self
}

/**
 * Remove scope from navigation
 * @param {string|Object} scope
 */
Nav.prototype.removeScope = function(scope) {
  var scopeName = ""

  // if name
  if (typeof scope === "string") {
    scopeName = scope
  }

  // if element
  if (typeof scope === "object") {
    scopeName = scope.getAttribute(options.attrScope)
  }

  scope = this.getScope(scopeName)

  if (scope) {
    var currentElement = scope.getCurrentElement()
    if (currentElement) {
      scope.cleanCurrentElement(currentElement)
    }
  }

  if (this.isCurrentScope(scope)) {
    DEBUGG && console.log("remove current scope")
    this._currentScope = null
  }

  // todo if object

  DEBUGG && console.log("remove scope", scopeName)
  this.getScopes()[scopeName] = undefined
  delete this.getScopes()[scopeName]
}

/**
 * Remove element from navigation
 * @param {HTMLElement} element
 * @returns {Nav}
 */
Nav.prototype.removeElement = function(element) {
  var scopes = this.getScopes()

  for (var scopeName in scopes) {
    scopes[scopeName].removeElement(element)
  }

  return this
}

/**
 * @todo change attr to {string} scopeName
 * Check is scope is current
 * @param {NavScope} scope
 * @returns {boolean}
 */
Nav.prototype.isCurrentScope = function(scope) {
  if (scope.name === this.getCurrentScope().name) {
    return true
  }

  return false
}

/**
 * Change current scope to scope
 * @param {string} scopeName
 * @returns {Nav}
 */
Nav.prototype.changeScope = function(scopeName, mouse = false) {
  this.disable()
  var scope = this.getScope(scopeName)

  this.enable()

  if (!scope) throw new Error(`Scope not found - ${scopeName}`)
  this._setCurrentScope(scope)

  if (mouse) return

  if (!scope.currentElement) {
    var firstElement = scope.getFirstElement()
    this.move(firstElement)
  } else this.move(scope.currentElement)

  return this
}

/**
 * Return previous scope
 * @returns {NavScope}
 */
Nav.prototype.getPrevScope = function() {
  if (!this._prevScope) {
    return false
  }

  return this._prevScope
}

Nav.prototype.prevScopeName = function() {
  var _prevScope = this.getPrevScope()
  if (!_prevScope) return false

  return _prevScope.name
}

/**
 * @todo throw exception if current scope not exist
 * Return current scope
 * @returns {NavScope}
 */
Nav.prototype.getCurrentScope = function() {
  if (!this._currentScope) {
    return false
  }

  return this._currentScope
}

Nav.prototype.currentScopeName = function(scopeName = null) {
  var scope = this.getCurrentScope()
  if (!scope) return false
  if (scopeName) return scope.name === scopeName
  return scope.name
}

/**
 * Set current scope
 * @param {NavScope} scope
 * @returns {Nav}
 */
Nav.prototype._setCurrentScope = function(scope) {
  var prevScope = this.getCurrentScope()
  var prevElement = null

  if (prevScope.name === scope.name) {
    DEBUGG && console.info(scope.name, ": scope is current now")
    return this
  }

  this._prevScope = prevScope
  var prevScopeEl = null
  if (this._prevScope) {
    prevElement = this._prevScope.getCurrentElement()
    prevScopeEl = this._prevScope.getScopeElement()

    prevScopeEl.removeAttribute(options.attrScopeCurrent)
    removeClass(prevScopeEl, options.attrScopeCurrent)

    if (prevElement) {
      removeClass(prevElement, options.attrElementCurrent)
    }
  }

  this._currentScope = scope
  addClass(scope.getScopeElement(), options.attrScopeCurrent)
  scope.getScopeElement().setAttribute(options.attrScopeCurrent, "true")
  scope.activate()
  this.trigger("scope-focus", scope.element)
  if (prevScopeEl) this.trigger("scope-blur", prevScopeEl)
  document.activeElement.blur()

  return this
}

/**
 * Return registered scopes
 * @returns {NavScope[]}
 */
Nav.prototype.getScopes = function() {
  return this._scopes
}

/**
 * @todo resolve if scope not found
 * @param {Event} event
 * @returns {string}
 */
Nav.prototype.getEventName = function(event) {
  var keyMapping = this.getKeyMapping()
  for (var i = 0; i < keyMapping.length; i++) {
    var item = keyMapping[i]
    if (item[0] == event.keyCode) {
      return item[1]
    }
  }

  return false
}

/**
 * @param {Event} event
 * @returns {*}
 */
Nav.prototype.getEventValue = function(event) {
  var keyMapping = this.getKeyMapping()
  for (var i = 0; i < keyMapping.length; i++) {
    var item = keyMapping[i]
    if (item[0] == event.keyCode) {
      if (typeof item[2] === "undefined") {
        return item[1]
      }

      return item[2]
    }
  }

  return false
}

/**
 * @todo throw exception if scope not found
 * Return scope by name
 * @param scopeName
 * @returns {NavScope}
 */
Nav.prototype.getScope = function(scopeName) {
  var scope = this.getScopes()[scopeName]

  if (!scope) {
    return false
  }

  return scope
}

Nav.prototype.isScopeExist = function(scopeName) {
  var scope = this.getScope(scopeName)

  if (scope) {
    return true
  }

  return false
}

/**
 * Return current nav element
 * @returns {HTMLElement}
 */
Nav.prototype.getCurrentElement = function() {
  return this.getCurrentScope().getCurrentElement()
}

/**
 * Add element to scope
 * @param {string} scopeName
 * @param {HTMLElement} element
 * @returns {Nav}
 */
Nav.prototype._addElementToScope = function(scopeName, element) {
  var self = this,
    scope = this.getScope(scopeName)

  if (!scope) {
    throw Error('Scope "' + scopeName + '" not found')
  }

  DEBUGG && console.info(scope.name, ": add new element")

  scope.addElement(element)

  element.setAttribute("tabindex", (scope.getNavigationElements().length + 1).toString())

  // trick listen remove from DOM
  var _remove = element.remove
  element.remove = function() {
    DEBUGG && console.log("----  remove element")
    scope.removeElement(element)
    _remove.call(element)
  }

  if (scope.isCurrentElement(element)) {
    DEBUGG && console.info(scope.name, ": new element is current")
    //scope.setCurrentElement(element)
  }

  return self
}

/**
 * Add element to navigation (find scope for element)
 * @param {HTMLElement} element
 */
Nav.prototype.addElement = function(element) {
  var scopeName = null,
    _el = element,
    attrName = options.attrScope

  while (scopeName === null && _el.parentElement !== null) {
    scopeName = _el.parentElement.getAttribute(attrName)
    _el = _el.parentElement
  }

  if (!scopeName) {
    throw new Error(element + " not belong to scope")
  }

  var scope = this.getScope(scopeName)

  if (!scope) {
    this.addScope(_el)
  }

  this._addElementToScope(scopeName, element)
  addClass(element, options.attrElement)
}

/**
 * Check is element in navigation
 * @param element
 * @returns {boolean}
 */
Nav.prototype.hasElement = function(element) {
  var scopes = this.getScopes()

  for (var scopeName in scopes) {
    var scope = scopes[scopeName]
    if (scope.hasElement(element)) {
      return true
    }
  }

  return false
}

/**
 * Find scope by element
 * @param {HTMLElement} element
 * @returns {NavScope|boolean}
 */
Nav.prototype.getScopeByElement = function(element) {
  var scopes = this.getScopes()

  for (var scopeName in arguments) {
    var scope = scopes[scopeName]
    if (scope.hasElement(element)) {
      return scope
    }
  }

  return false
}

/**
 * Handle event interface
 * @param {Event} event
 */
Nav.prototype.handleEvent = function(event) {
  event.type === "keydown" && this.onKeyDown(event)
  event.type === "keyup" && this.onKeyUp(event)
}

/**
 * Main function in navigation for handle all keyboard events
 * and trigger registered event
 * @param {Event} event
 */
Nav.prototype.onKeyDown = function(event, keyup = true) {
  if (event?.preventDefault) event.preventDefault()

  __._api?.Widget?.blockNavigation(event)

  _$.vue.$hotelServiceMenu(event)
  if (keyup && options.holding) return
  else if (keyup) options.holding = true

  if (!options.enable.status && !options.enable.excepted.length) return false

  var self = this,
    currentScope = self.getCurrentScope()

  if (!currentScope) {
    DEBUGG && console.error("current scope not found")
    return
  }

  var currentElement = currentScope.getCurrentElement()

  if (!currentElement) {
    DEBUGG && console.info("current element not found")
    return
  }

  var eventName = this.getEventName(event)
  var eventValue = this.getEventValue(event)

  if (!eventName && event.key) {
    var regex = new RegExp("^[a-zA-Z0-9@\\-_.\\s]$")
    if (regex.test(event.key)) {
      this.trigger("numpad", currentElement, event.key)
    }
  }

  if (eventName && !options.enable.status && options.enable.excepted.length) {
    if (eventName && options.enable.excepted.indexOf(eventName) > -1) {
      _$.vue.$emit(prefix + "-" + eventName, eventValue)

      if (options.enable.sendEventToElements) {
        this.trigger(eventName, currentElement, eventValue)
        this.trigger(eventName, currentScope.element, eventValue)
      }

      DEBUGG && console.log("keycode: ", +event.keyCode, "eventName: ", eventName, "eventValue: ", eventValue)
    }
    return false
  }

  DEBUGG && console.log("keycode: ", +event.keyCode, "eventName: ", eventName, "eventValue: ", eventValue)

  if (eventName && ["left", "right", "up", "down"].indexOf(eventName) > -1) {
    self.move(eventName)
  }

  // if declared event / dispatch declared event
  if (eventName) {
    this.trigger(eventName, currentElement, eventValue)
    this.trigger(eventName, currentScope.element, eventValue)
    this.trigger(eventName, document, eventValue)

    this.createTimeout()
  }
}

Nav.prototype.onKeyUp = function() {
  options.holding = false
}

/* For Channel Management or Something Like That */
Nav.prototype.getIndexOfElement = function(id) {
  return this._currentScope.navigationElements.findIndex(element => {
    if (id) return element.id === id
    else return element === this._currentScope.currentElement
  })
}

Nav.prototype.findAndSet = function(id) {
  var index = this.getIndexOfElement(id),
    element = this._currentScope.navigationElements[index]
  if (!element) return false

  this.move(element)
  return true
}

Nav.prototype.jump = function(count) {
  var currentIndex = this.getIndexOfElement()
  var targetIndex = currentIndex + count

  if (targetIndex < 0) targetIndex = 0
  else if (targetIndex > this._currentScope.navigationElements.length - 1) targetIndex = this._currentScope.navigationElements.length - 1

  this.move(this._currentScope.navigationElements[targetIndex])
  return true
}
/* For Channel Management or Something Like That */

Nav.prototype.move = function(direction) {
  if (!direction) return

  var self = this
  var currentScope = self.getCurrentScope()
  var currentElement = currentScope.getCurrentElement()
  var nextElement
  if (typeof direction === "object") {
    nextElement = direction
    if (currentScope.name !== "player") scroll(currentScope, nextElement, true)
  } else nextElement = currentScope.getNextElement(direction)

  if (!nextElement) nextElement = this.directionLoop(direction)

  if (nextElement) {
    currentScope.setCurrentElement(nextElement)
    if (currentElement) this.trigger("move", currentElement)
    this.trigger("focus", nextElement)
  } else this.directionScope(direction)

  return true
}

Nav.prototype.directionLoop = function(direction) {
  var self = this
  var currentScope = self.getCurrentScope()
  var elementLength = currentScope.navigationElements.length

  if (!currentScope.element.dataset.loop) return false
  if (!elementLength) return false

  var nextElement

  switch (currentScope.element.dataset.loop) {
    case "horizontal":
      if (direction === "right") nextElement = currentScope.navigationElements[0]
      if (direction === "left") nextElement = currentScope.navigationElements[elementLength - 1]
      break
    case "vertical":
      if (direction === "down") nextElement = currentScope.navigationElements[0]
      if (direction === "up") nextElement = currentScope.navigationElements[elementLength - 1]
      break
  }
  if (nextElement) scroll(currentScope, nextElement, true)

  return nextElement
}

Nav.prototype.directionScope = function(direction) {
  var self = this
  var currentScope = self.getCurrentScope()

  if (!currentScope.element.dataset[direction]) return this.trigger(`noway-${direction}`, currentScope.element)
  var scopes = currentScope.element.dataset[direction].split("|")

  for (const scope of scopes) {
    if (!this.isScopeExist(scope)) continue
    if (!this._scopes[scope].element.offsetParent) continue

    this.changeScope(scope)
    break
  }

  return true
}

/**
 * Trigger navigation event
 * @param {string} name
 * @param {HTMLElement} target
 */
Nav.prototype.trigger = function(name, target, value, bubble = false) {
  triggerEvent(name, target, value, bubble)
}

/**
 * Scroll to current element
 */
Nav.prototype.scrollToCurrentElement = function() {
  var scope = this.getCurrentScope()
  var element = scope.getCurrentElement()
  scroll(scope, element, true)
}

/**
 * Navigation scope
 * @param element
 * @returns {NavScope}
 * @constructor
 */
var NavScope = function(element) {
  var self = this
  self.name = element.getAttribute(options.attrScope)
  DEBUGG && console.info(self.name, ": scope create")
  self.element = element
  self.navigationElements = []
  self.currentElement = null
  self.activate()
  self.FOV = parseInt(element.getAttribute(options.attrScopeFOV), 10)
  return self
}

/**
 * Activate scope
 * @returns {NavScope}
 */
NavScope.prototype.activate = function() {
  DEBUGG && console.log(this.name, ": activated, elements", this.navigationElements.length)

  this.currentElement = this.getCurrentElement()

  if (!this.currentElement) {
    DEBUGG && console.info(this.name, ": not found current element")
  } else {
    addClass(this.currentElement, options.attrElementCurrent)
  }

  return this
}

/**
 * Add element to scope
 * @param {HTMLElement} element
 * @returns {NavScope}
 */
NavScope.prototype.addElement = function(element) {
  if (this.navigationElements.indexOf(element) > -1) {
    return this
  }

  this.navigationElements.push(element)

  return this
}

/**
 * Remove element from scope
 * @param {HTMLElement} element
 * @returns {NavScope}
 */
NavScope.prototype.removeElement = function(element) {
  var elements = this.getNavigationElements()

  var index = elements.indexOf(element)

  if (this.isCurrentElement(element)) {
    DEBUGG && console.info("remove current element")
  }

  element.removeAttribute(options.attrElement)
  removeClass(element, options.attrElement)

  if (index > -1) {
    this.navigationElements.splice(index, 1)
  }

  return this
}

/**
 * Check is element in scope
 * @param {HTMLElement} element
 * @returns {boolean}
 */
NavScope.prototype.hasElement = function(element) {
  var elements = this.getNavigationElements()

  if (elements.indexOf(element) !== -1) {
    return true
  }

  return false
}

/**
 * Return scope html container
 * @returns {HTMLElement}
 */
NavScope.prototype.getScopeElement = function() {
  if (!this.element) {
    return false
  }

  return this.element
}

/**
 * Return current element
 * @returns {HTMLElement}
 */
NavScope.prototype.getCurrentElement = function() {
  if (this.currentElement) {
    return this.currentElement
  }

  var navElements = this.navigationElements,
    currentElement = false

  for (var i = 0, n = navElements.length; i < n; i++) {
    if (this.isCurrentElement(navElements[i])) {
      currentElement = navElements[i]
      // @todo break loop
    }
  }

  return currentElement
}

/**
 * Get first element element from scope
 * @returns {HTMLElement|boolean}
 */
NavScope.prototype.getFirstElement = function() {
  var result = this.getNavigationElements().find(e => e.offsetParent)
  return result
}

/**
 * Get all navigation elements from scope
 * @returns {HTMLElement[]}
 */
NavScope.prototype.getNavigationElements = function() {
  return this.navigationElements
}

/**
 * Check is current element
 * @param {HTMLElement} element
 * @returns {boolean}
 */
NavScope.prototype.isCurrentElement = function(element) {
  var attr = element.getAttribute(options.attrElementCurrent)
  if (attr === "" || attr === "true") {
    return true
  }

  return false
}

/**
 * Set current element
 * @param {HTMLElement} element
 */
NavScope.prototype.setCurrentElement = function(element) {
  var prevElement = this.getCurrentElement()
  this.currentElement = element

  if (prevElement) {
    this.cleanCurrentElement(prevElement)
  }

  this.currentElement = element
  addClass(this.currentElement, options.attrElementCurrent)

  this.currentElement.setAttribute(options.attrElementCurrent, "true")
}

NavScope.prototype.cleanCurrentElement = function(element) {
  element.removeAttribute(options.attrElementCurrent)
  removeClass(element, options.attrElementCurrent)
}

/**
 * Get next element by direction
 * @param {string} direction
 * @returns {HTMLElement|boolean}
 */
NavScope.prototype.getNextElement = function(direction, _element) {
  var current = _element || this.getCurrentElement()

  if (!current) {
    DEBUGG && console.info("Current element not found")
    return false
  }

  if (["up", "down", "left", "right"].indexOf(direction) === -1) {
    var error = "Not declared direction: " + direction
    DEBUGG && console.error(error)
    throw Error(error)
  }

  var windowSize = getWindowSize(),
    currentElementFOV = parseInt(current.getAttribute(options.attrElementFOV), 10),
    FOV = currentElementFOV || this.FOV || options.FOV,
    halfFOV = FOV / 2,
    distance = null,
    index,
    navElements = this.getNavigationElements(),
    currentElementRect = current.getBoundingClientRect(),
    currentElementX = currentElementRect.left + currentElementRect.width / 2,
    currentElementY = currentElementRect.top + currentElementRect.height / 2,
    currentElementCenter = new Point(currentElementX, currentElementY)

  // offset in the direction of motion
  if ("up" == direction) {
    currentElementCenter.y = currentElementRect.top
  } else if ("down" == direction) {
    currentElementCenter.y = currentElementRect.top + currentElementRect.height
  } else if ("left" == direction) {
    currentElementCenter.x = currentElementRect.left
  } else if ("right" == direction) {
    currentElementCenter.x = currentElementRect.left + currentElementRect.width
  }

  for (var i = 0; i < navElements.length; i++) {
    var el = navElements[i],
      isHidden = el.offsetParent == null,
      isCurrent = navElements.indexOf(current) == i,
      inDOM = document.body.contains(el)

    if (isHidden || isCurrent || !inDOM) {
      continue
    }

    var elementRect = el.getBoundingClientRect(),
      elementCenterX = elementRect.left + elementRect.width / 2,
      elementCenterY = elementRect.top + elementRect.height / 2,
      elementCenter = new Point(elementCenterX, elementCenterY),
      elementDistance = getDistance(currentElementCenter, elementCenter),
      angle = getAngle(currentElementCenter, elementCenter)

    // angle normalize [0,360]
    if (angle < 0) angle += 360

    // 45  90  135
    //  0      180
    //315 270  225
    var inFOV = false

    // left
    if (direction == "left" && ((angle > 360 - halfFOV && angle <= 360) || (angle >= 0 && angle < 0 + halfFOV))) {
      inFOV = true
    } else if (direction == "down" && angle > 270 - halfFOV && angle < 270 + halfFOV) {
      inFOV = true
    } else if (direction == "right" && angle > 180 - halfFOV && angle < 180 + halfFOV) {
      inFOV = true
    } else if (direction == "up" && angle > 90 - halfFOV && angle < 90 + halfFOV) {
      inFOV = true
    }

    // Intersection
    var x1 = elementRect.left,
      x2 = elementRect.left + elementRect.width,
      y1 = elementRect.top,
      y2 = elementRect.top + elementRect.height

    var intersections = [],
      endPoint,
      line

    if ("up" == direction) {
      // bottom line
      line = { start: new Point(x1, y2), end: new Point(x2, y2) }
      endPoint = new Point(currentElementCenter.x, 0)
    } else if ("down" == direction) {
      // top line
      line = { start: new Point(x1, y1), end: new Point(x2, y1) }
      endPoint = new Point(currentElementCenter.x, windowSize.height)
    } else if ("left" == direction) {
      // right line
      line = { start: new Point(x2, y1), end: new Point(x2, y2) }
      endPoint = new Point(0, currentElementCenter.y)
    } else if ("right" == direction) {
      // left line
      line = { start: new Point(x1, y1), end: new Point(x1, y2) }
      endPoint = new Point(windowSize.width, currentElementCenter.y)
    }

    var intersection = getIntersection(endPoint, currentElementCenter, line.start, line.end)

    if (intersection) {
      elementDistance = getDistance(currentElementCenter, intersection)
      intersections.push(intersection)
    }

    if (!inFOV && !intersections.length) {
      continue
    }

    // save to best way
    if (distance === null || distance > elementDistance) {
      distance = elementDistance
      index = i
    }
  }

  // if not found
  if (typeof index === "undefined") {
    return false
  }

  var nextElement = navElements[index]
  scroll(this, nextElement, direction)

  return nextElement
}

/**
 * Function for scroll
 * @param {HTMLElement} scrollContainer
 * @param {HTMLElement} element
 */

Nav.prototype.scroll = function(_scope, element) {
  return scroll(_scope, element)
}

function scroll(_scope, element) {
  if (!element) return false
  var _offsetParent = element.offsetParent
  if (!_offsetParent) return false

  let scope = _scope.element,
    scroll = scope.dataset.scroll || "start"

  var scrollLeft = element.offsetLeft
  var scrollTop = element.offsetTop
  var offsetX = scope.dataset.offsetx ? parseInt(scope.dataset.offsetx) : 0
  var offsetY = scope.dataset.offsety ? parseInt(scope.dataset.offsety) : 0

  if (scroll === "end") {
    scrollLeft += element.offsetWidth - scope.offsetWidth + offsetX
    scrollTop += element.offsetHeight - scope.offsetHeight + offsetY
  } else if (scroll === "center") {
    scrollLeft += element.offsetWidth / 2 - (scope.offsetWidth + offsetX) / 2
    scrollTop += element.offsetHeight / 2 - (scope.offsetHeight + offsetY) / 2
  } else {
    scrollLeft += offsetX
    scrollTop += offsetY
  }

  if (scope.dataset.noanimate !== "true" && store.state.theme.options.animate)
    $(scope)
      .stop()
      .animate({ scrollLeft: scrollLeft, scrollTop: scrollTop }, 200)
  else {
    scope.scrollLeft = scrollLeft
    scope.scrollTop = scrollTop
  }
}

/**
 * Find and return HTMLElements by attribute name
 * @param {HTMLElement[]} elements
 * @param {string} attribute
 * @returns {HTMLElement[]}
 */
function getElementsByAttributeName(elements, attribute) {
  var result = []
  for (var i = 0, n = elements.length; i < n; i++) {
    if (elements[i].getAttribute(attribute) !== null) {
      result.push(elements[i])
    }

    if (elements[i].children.length > 0) {
      var childrens = getElementsByAttributeName(elements[i].children, attribute)
      if (childrens.length > 0) {
        result = result.concat(childrens)
      }
    }
  }

  return result
}

/**
 * Add class to HTMLElement
 * @param {HTMLElement} element
 * @param {string} className
 */
function addClass(element, className) {
  removeClass(element, className)
  element.className = element.className
    .split(" ")
    .concat([className])
    .join(" ")
    .trim()
}

/**
 * Remove class from HTMLElement
 * @param {HTMLElement} element
 * @param {string} className
 */
function removeClass(element, className) {
  var classes = element.className.split(" ")

  for (var i = classes.length - 1; i >= 0; i--) {
    if (classes[i] == className) {
      classes.splice(i, 1)
    }
  }

  element.className = classes.join(" ")
}

/**
 * Clone object
 * @param obj
 * @returns {object}
 */
function clone(obj) {
  if (null == obj || "object" != typeof obj) return obj
  var copy = obj.constructor()
  for (var attr in obj) {
    if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr]
  }
  return copy
}

function Point(x, y) {
  this.x = x
  this.y = y
}

function Point2f(start, type, end) {
  if (type == "-") {
    return { x: start.x - end.x, y: start.y - end.y }
  } else if (type == "*") {
    return { x: start.x * end.x, y: start.y * end.y }
  } else if (type == "+") {
    return { x: start.x + end.x, y: start.y + end.y }
  } else if (type == "/") {
    return { x: start.x / end.x, y: start.y / end.y }
  }
}

function getIntersection(start1, end1, start2, end2) {
  var dir1 = Point2f(end1, "-", start1),
    dir2 = Point2f(end2, "-", start2)

  // считаем уравнения прямых проходящих через отрезки
  var a1 = -dir1.y
  var b1 = +dir1.x
  var d1 = -(a1 * start1.x + b1 * start1.y)

  var a2 = -dir2.y
  var b2 = +dir2.x
  var d2 = -(a2 * start2.x + b2 * start2.y)

  // подставляем концы отрезков, для выяснения в каких полуплоскотях они
  var seg1_line2_start = a2 * start1.x + b2 * start1.y + d2
  var seg1_line2_end = a2 * end1.x + b2 * end1.y + d2

  var seg2_line1_start = a1 * start2.x + b1 * start2.y + d1
  var seg2_line1_end = a1 * end2.x + b1 * end2.y + d1

  // если концы одного отрезка имеют один знак, значит он в одной полуплоскости и пересечения нет
  if (seg1_line2_start * seg1_line2_end >= 0 || seg2_line1_start * seg2_line1_end >= 0) return false

  var u = seg1_line2_start / (seg1_line2_start - seg1_line2_end)

  var pin_out = Point2f({ x: u, y: u }, "*", dir1)

  return Point2f(start1, "+", pin_out)
}

function getAngle(pointA, pointB) {
  var diff = Point2f(pointA, "-", pointB)
  var angle = Math.round(Math.atan2(diff.y, diff.x) * (180 / Math.PI))
  return angle
}

function getDistance(pointA, pointB) {
  var diff = Point2f(pointA, "-", pointB)
  var dis = Math.round(Math.pow(diff.x * diff.x + diff.y * diff.y, 0.5))
  return dis
}

function getWindowSize() {
  var w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName("body")[0],
    width = w.innerWidth || e.clientWidth || g.clientWidth,
    height = w.innerHeight || e.clientHeight || g.clientHeight

  return { width: width, height: height }
}

function triggerEvent(name, target, value, bubble) {
  var eventName = options.prefix + "-" + name
  var navEvent = null

  if (typeof CustomEvent === "function") {
    navEvent = new CustomEvent(eventName, {
      bubbles: bubble,
      detail: { value: value }
    })
  } else if (typeof document.createEvent === "function") {
    navEvent = document.createEvent("CustomEvent")
    navEvent.initCustomEvent(eventName, bubble, true, { value: value })
  } else {
    DEBUGG && console.log("Can\t create custom event")
    throw new Error("Can\t create custom event")
  }

  target.dispatchEvent(navEvent)
}

export default new Nav()
